import ListTemplate from "components/ListTemplate";
import { CompanySidePanel } from "components/SidePanel/Company/CompanySidePanel";
import Tag from "components/Tag/Tag";
import TagList from "components/Tag/TagList";
import React from "react";
import { useLoaderData } from "react-router";
import FavoriteIcon from "../../components/Atoms/FavoriteIcon";
import Filters from "./Filters";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";

const NameElement = ({ item }: { item: server.dto.ArtistForList }) => {
  return <div className="flex-column gap-small">
    <div>
      <CompanySidePanel type="artist"
        trigger={<a>{item.name}</a>}
        companyId={item.artistId}
      />
    </div>
    {!item.displayInFilters && <div><Tag color="red-basic" label={RESX.Artist.NoLongerActive} /></div>}
  </div>;
};

const ArtistListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ArtistListFrontModel>();

  return <ListTemplate
    title={site.currentEnvironment.functionGroups.artist.plural}
    filterSet="company_Artist_List"
    defaultFilters={viewModel.defaultFilters}
    initialInstruction={viewModel.initialInstruction}
    fetchFunction={window.CoreApi.Artist.Paginated}
    getId={item => item.artistId}
    layout={{
      type: "table",
      columns: [{
        key: "favorite",
        header: "",
        render: item => <FavoriteIcon artistId={item.artistId} isFavorite={item.isFavorite} />,
        size: "fit-content(38px)"
      }, {
        key: "name",
        header: RESX.GeneralLabels.Name,
        render: item => <NameElement item={item} />,
        size: "1fr"
      }, {
        key: "tags",
        header: "",
        render: item => <TagList tags={item.tags} version="short" />,
        size: "fit-content(400px)"
      }]
    }}
    filters={<Filters initialTags={viewModel.tags} />}
    functions={{
      mapFilterValuesToInstruction,
      mapResponseToFilterValues
    }}
  />;
};

export default ArtistListApp;
